import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import {
  Menu, MenuItem,
  ListItem, ListItemText,
} from '@mui/material';
import Grid from "@mui/material/Grid2";
import {
  Person
} from "@mui/icons-material";

import { User } from "@models";

import DandDAPI from "@utilities/smart_api";
import ModalOrDrawer from '@components/display/ModalOrDrawer';
import UserIndex from '@views/user';
import { SBSection } from '@dndModels';

interface Props {
}

const api = DandDAPI.getInstance();

export default function UserMenu({
}: Props) {
  const [navigateTo, setNavigateTo] = useState("");
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<any>(null);
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    if (navigateTo !== "") {
      setAnchorEl(null);
      // setOpen(false);
      setNavigateTo("");
    }
  }, [navigateTo, setNavigateTo]);

  const adminMode = () => {
    if (api.user && api.user.is_admin) {
      api.user.admin = !api.user.admin;
      if (api.user.admin) {
        for (const sb of api.source_books) {
          const removeCreatedSBSections = (section: SBSection) => {
            // This removes SBSections that aren't in the db, 
            // so the UI doesn't pretend they're in the db when we're editing it.
            if (section.special_type !== "None") {
              section.subsections = section.subsections.filter(o => o._id !== "");
            }
            for (const subsection of section.subsections) {
              removeCreatedSBSections(subsection);
            }
          }
          for (const section of sb.sections) {
            removeCreatedSBSections(section);
          }
        }
      }
      api.subscription_holder.reload();
    }
    setAnchorEl(null);
  }

  const viewBlockedMode = () => {
    setAnchorEl(null);
    if (api.user && api.user && api.user.is_admin) {
      api.user.view_blocked_source_books = !api.user.view_blocked_source_books;
      // Blocked source books are always loaded - this only changes whether they're shown.
      api.subscription_holder.dataTypeLoaded("source_book"); // This is to trigger refreshing of details, which almost always include the source books.
    }
  }

  const unSpoofUser = () => {
    api.unSpoofUser();
    setAnchorEl(null);
  }

  const reloadUser = async () => {
    setAnchorEl(null);
    if (api.user && api.true_user) {
      setProcessing(true);
      const res = await api.getPlayerObject({ data_type: "user", id: api.user._id });
      if (res instanceof User) {
        if (api.spoofing) {
          api.user = res;
        } else {
          api.true_user = res;
        }
      }
      setProcessing(false);
      api.subscription_holder.reload();
    }
  }

  const renderAdminOptions = () => {
    return (
      <>
        <MenuItem 
          disabled={processing}
          onClick={() => {
            // setNavigateTo(`/user`);
            setOpen(true);
            setAnchorEl(null);
          }}>
          <ListItemText primary="All Users" />
        </MenuItem>
        <MenuItem 
          disabled={processing}
          onClick={adminMode}>
          <ListItemText primary="Toggle Admin Mode" />
        </MenuItem>
        <MenuItem 
          disabled={processing}
          onClick={viewBlockedMode}>
          <ListItemText primary="Toggle View Blocked Mode" />
        </MenuItem>
        { api.spoofing &&
          <MenuItem 
            disabled={processing}
            onClick={unSpoofUser}>
            <ListItemText primary="End Spoof" />
          </MenuItem>
        }
      </>
    );
  }

  const renderUserName = () => {
    if (api.spoofing && api.true_user) {
      return ( 
        <Grid container spacing={0} direction="row">
          <Grid size={12}>{api.true_user.use_name}</Grid>
          <Grid size={12}>spoofing as {api.user?.use_name}</Grid>
        </Grid>
      );
    }
    return ` ${api.user?.use_name}`;
  }

  const renderExtras = () => {
    return (
      <ModalOrDrawer
        open={open}
        onClose={() => setOpen(false)}
      >
        <>
          <UserIndex />
        </>
      </ModalOrDrawer>
    );
  }
  
  if (navigateTo !== "") {
    return <Navigate to={navigateTo} />;
  } else { 
    return (
      <span className="float-right">
        <ListItem 
          aria-controls="user-menu" aria-haspopup="true"
          style={{cursor: "pointer"}} 
          onClick={(event: any) => {
            setAnchorEl(event.currentTarget);
            // setOpen(true);
          }} 
          className="curvedButton float-right">
          <Person/>
          <ListItemText primary={renderUserName()}/>
        </ListItem>
        <Menu
          id="customized-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={() => {
            setAnchorEl(null);
            // setOpen(false);
          }}
          elevation={0}
          anchorReference={undefined}
          // getContentAnchorEl={null}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}>
          <MenuItem
            disabled={processing}
            onClick={() => {
              setAnchorEl(null);
              setNavigateTo(`/user/${api.user?._id}`);
            }}>
            <ListItemText primary="My Account" />
          </MenuItem>
          { api.true_user && api.true_user.is_admin &&
            renderAdminOptions()
          }
          <MenuItem
            disabled={processing}
            onClick={reloadUser}>
            <ListItemText primary="Reload" />
          </MenuItem>
          <MenuItem
            disabled={processing}
            onClick={() => {
              setAnchorEl(null);
              api.subscription_holder.logout();
            }}>
            <ListItemText primary="Logout" />
          </MenuItem>
        </Menu>
        { renderExtras() }
      </span>
    );
  }
}